<div *ngIf="initialized">
  <div [editorHTML]="termsText"></div>
</div>
